/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Page SubscriberId PersonalData Tab component
 *
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.12.0
 */

import { Fragment, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Skeleton } from '../../../../../components/common';
import { useSubscriberIdContext } from '../../../context';
import SubscriberIdError from '../../SubscriberIdError';
import { personalDataApi, useGetPersonalDataMetaQuery } from '../store';
import SubscriberIdPersonalDataEdit from './edit/PersonalDataEdit';
import { SubscriberIdPersonalDataStyled } from './styled/SubscriberIdPersonalDataStyled';
import { SubscriberIdPersonalDataSkeleton } from './SubscriberIdPersonalDataSkeleton';
import SubscriberIdPersonalDataStatus from './SubscriberIdPersonalDataStatus';
import SubscriberPersonalDataInfo from './SubscriberPersonalDataInfo';

const SubscriberIdPersonalData = () => {

    const { subscriberId } = useSubscriberIdContext();

    const [isEditMode, setEditMode] = useState(false);

    const dispatch = useDispatch();

    const { data, isFetching, isSuccess, error, refetch } = useGetPersonalDataMetaQuery(subscriberId);

    const onSuccess = () => {
        setEditMode(false);
        dispatch(personalDataApi.util.invalidateTags(['PersonalDataMeta']));
    };

    const onCancel = () => {
        setEditMode(false);
        refetch();
    };


    if (error || (isSuccess && !data)) return <SubscriberIdError refetch={refetch}/>;
    if (isFetching) return <Skeleton isLoading render={SubscriberIdPersonalDataSkeleton}/>;

    return (
        <SubscriberIdPersonalDataStyled>
            {
                isEditMode
                    /* Edit form */
                    ? <SubscriberIdPersonalDataEdit
                        onCancel={onCancel}
                        onSuccess={onSuccess}
                    />
                    /* Personal Info */
                    : <Fragment>
                        <SubscriberIdPersonalDataStatus/>
                        <SubscriberPersonalDataInfo onEdit={() => setEditMode(true)}/>
                    </Fragment>
            }
        </SubscriberIdPersonalDataStyled>
    );
};

export default SubscriberIdPersonalData;
